import compose from "recompose/compose";
import { withRouter } from "react-router";
import LogoutMutation from "./LogoutMutation.gql";
import makeCommandDispatcher from "web/core/apollo/makeCommandDispatcher";
import { withShop } from "web/core/shop/ShopContext";
import { setRefreshing } from "theme/modules/Router/useRefreshing";

export default () => {
  return compose(
    withShop(),
    withRouter,
    makeCommandDispatcher({
      logout: (props) => (redirectPath) => ({
        options: {
          mutation: LogoutMutation,
          refetchQueries: ["User", "Cart", "CartQty"],
        },
        callback: ({ status, data }) => {
          if (status === "success") {
            setRefreshing(props.history, props.location)(true);
            window.location.href = props.shop.url + "/";
          } else {
            console.error("Logout failure");
          }
        },
      }),
    })
  );
};
